import React from "react";

const EnterEmailSvg = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="15"
        viewBox="0 0 18 15"
        fill="none"
      >
        <path
          d="M13 14H5C2.6 14 1 12.8529 1 10.1765V4.82353C1 2.14706 2.6 1 5 1H13C15.4 1 17 2.14706 17 4.82353V10.1765C17 12.8529 15.4 14 13 14Z"
          stroke="#899CBB"
          stroke-width="1.32"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.4158 4.2644L9.97824 7.54216C9.402 7.96772 8.59784 7.96772 8.0216 7.54216L3.58398 4.2644"
          stroke="#899CBB"
          stroke-width="1.32"
          stroke-linecap="round"
        />
      </svg>
    </div>
  );
};

export default EnterEmailSvg;
